import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

// Tabela de exemplo: você pode movê-la para outro módulo ou buscar da API
const FEE_TABLE = {
  elo: {
    1: 3.22,
    2: 3.67,
    3: 3.67,
    4: 3.67,
    5: 3.67,
    6: 3.67,
    7: 4.14,
    8: 4.14,
    9: 4.14,
    10: 4.14,
    11: 4.14,
    12: 4.14,
    13: 4.14,
    14: 4.14,
    15: 4.14,
    16: 4.14,
    17: 4.14,
    18: 4.14,
  },
  hipercard: {
    1: 2.29,
    2: 3.3,
    3: 3.3,
    4: 3.3,
    5: 3.3,
    6: 3.3,
    7: 3.69,
    8: 3.69,
    9: 3.69,
    10: 3.69,
    11: 3.69,
    12: 3.69,
    // 13–18: sem oferta s/ juros
  },
  mastercard: {
    1: 2.43,
    2: 3.15,
    3: 3.15,
    4: 3.15,
    5: 3.15,
    6: 3.15,
    7: 3.44,
    8: 3.44,
    9: 3.44,
    10: 3.44,
    11: 3.44,
    12: 3.44,
    13: 3.44,
    14: 3.44,
    15: 3.44,
    16: 3.44,
    17: 3.44,
    18: 3.44,
  },
  visa: {
    1: 2.43,
    2: 3.15,
    3: 3.15,
    4: 3.15,
    5: 3.15,
    6: 3.15,
    7: 3.44,
    8: 3.44,
    9: 3.44,
    10: 3.44,
    11: 3.44,
    12: 3.44,
    13: 3.44,
    14: 3.44,
    15: 3.44,
    16: 3.44,
    17: 3.44,
    18: 3.44,
  },
  americanExpress: {
    1: 3.34,
    2: 3.42,
    3: 3.42,
    4: 3.42,
    5: 3.42,
    6: 3.42,
    7: 3.54,
    8: 3.54,
    9: 3.54,
    10: 3.54,
    11: 3.54,
    12: 3.54,
    // 13–18: sem oferta s/ juros
  },
  cabal: {
    1: 5.0,
    2: 5.25,
    3: 5.25,
    4: 5.25,
    5: 5.25,
    6: 5.25,
    7: 5.5,
    8: 5.5,
    9: 5.5,
    10: 5.5,
    11: 5.5,
    12: 5.5,
    // 13–18: sem oferta s/ juros
  },
  unionPay: {
    1: 4.0,
    2: 4.0,
    3: 4.0,
    4: 4.0,
    5: 4.0,
    6: 4.0,
    7: 4.0,
    8: 4.0,
    9: 4.0,
    10: 4.0,
    11: 4.0,
    12: 4.0,
    // 13–18: sem oferta s/ juros
  },
};

export default function FeeSelectorModal({
  show,
  onHide,
  initialBrand,
  initialInstallments,
  onConfirm,
}) {
  const [brand, setBrand] = useState(initialBrand || "");
  const [installments, setInstallments] = useState(initialInstallments || 1);

  // Se o parent trocar as props de inicialização, reflita aqui:
  useEffect(() => {
    setBrand(initialBrand || "");
    setInstallments(initialInstallments || 1);
  }, [initialBrand, initialInstallments]);

  const tax = brand ? FEE_TABLE[brand]?.[installments] ?? 0 : 0;

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Escolher bandeira e parcelas</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Bandeira</Form.Label>
          <Form.Select value={brand} onChange={(e) => setBrand(e.target.value)}>
            <option value="" disabled>
              -- selecione --
            </option>
            <option value="visa">Visa</option>
            <option value="mastercard">Mastercard</option>
            <option value="americanExpress">American Express</option>
            <option value="cabal">Cabal</option>
            <option value="unionPay">UnionPay</option>
            <option value="elo">Elo</option>
            <option value="hipercard">Hipercard</option>
            {/* outras bandeiras */}
          </Form.Select>
        </Form.Group>

        <Form.Group className="mt-3">
          <Form.Label>Parcelas</Form.Label>
          <Form.Select
            value={installments}
            onChange={(e) => setInstallments(Number(e.target.value))}>
            {[
              1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
            ].map((n) => (
              <option key={n} value={n}>
                {n}x
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        {brand && (
          <div className="mt-3">
            <strong>Taxa aplicada: {tax}%</strong>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={() => onConfirm({ brand, installments, tax })}
          disabled={!brand}>
          Confirmar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
